import { render, staticRenderFns } from "./RulePage.vue?vue&type=template&id=7968d5ff&scoped=true&"
import script from "./RulePage.vue?vue&type=script&lang=js&"
export * from "./RulePage.vue?vue&type=script&lang=js&"
import style0 from "./RulePage.vue?vue&type=style&index=0&id=7968d5ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968d5ff",
  null
  
)

export default component.exports